// extracted by mini-css-extract-plugin
module.exports = {"content":"ArtistInfo_content__368_e","background":"ArtistInfo_background__o-Ca3"};